export var defaultProps = {
    className: '',
    style: undefined,
    type: 'default',
    isDot: false,
    maxCount: 99,
    showZero: false,
    size: 'normal',
    offset: [0, 0],
    isAnimated: false,
};
export var defaultScrollNumberProps = {
    showZero: false,
};
